import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function NoviScheduleLocation() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2711">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2712">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-2713">
          <div data-id="element-2714">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2715">Class Times</h2>
            <ScheduleTable data-id="element-2716" />
          </div>
          <div data-id="element-2717">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2718">Location Details</h2>
            <LocationBlock data-id="element-2719" />
          </div>
        </div>
      </div>
    </section>;
}